var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.13 174.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.13,87.07C174.13,39.18,134.96,0,87.07,0,39.18,0,0,39.18,0,87.07s39.18,87.07,87.07,87.07c47.89,0,87.06-39.19,87.06-87.07ZM85.65,133.59c-4.93-4.91-4.93-12.97,0-17.9l15.92-15.92h-59.58c-7.08,0-12.77-5.69-12.77-12.77s5.69-12.58,12.77-12.58h59.58s-15.92-15.92-15.92-15.92c-4.93-4.93-4.93-12.97,0-17.89,2.55-2.57,5.89-3.74,9.04-3.74,3.35,0,6.48,1.17,9.05,3.74l37.36,37.54c.58.6,1.18,1.19,1.77,1.97.19.21.19.6.39.8.2.38.58.98.58,1.36.21.41.39.79.39,1.19.19.41.4.78.4,1.18.39,1.56.39,3.34,0,4.91,0,.41-.21.8-.4,1.19,0,.4-.18.78-.39,1.17,0,.39-.39.79-.58,1.18-.2.39-.2.79-.39,1-.59.77-1.19,1.37-1.77,1.95l-37.36,37.56c-5.12,4.91-12.97,4.91-18.09,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.783975b30d6ad0563134c8763e28cb38.svg";
export { ForwardRef as ReactComponent };